import { useQuery } from 'react-query';
import { PipelineJobStage } from '../../../entities/v1/applicant_tracking/PipelineJobStage';
import { PipelineJobStagesService } from '../../../services/v1/applicant_tracking/PipelineJobStagesService';

export const usePipelineJobStages = (jobId?: number) =>
  useQuery<PipelineJobStage[]>(
    ['jobs', jobId, 'pipeline-stages'],
    async () => {
      if (!jobId) return [];

      const result = await PipelineJobStagesService.list(jobId!);

      return result.jobStages;
    },
    {
      enabled: !!jobId,
    },
  );
